<template>
  <div>
    <div v-if="voucherType === 'recommend'" class="ticket-notice">
      <p class="ticket-noti-tit"><span class="col-purple-dark">이용권</span>주의사항</p>
      <div class="tic-notice-right">
        <p class="dot-text"><span>콘텐츠 제공사의 사정에 따라 일부 콘텐츠는 FHD 화질을 지원하지 않을 수 있습니다.</span></p>
        <p class="dot-text"><span>FHD 이용권 구매 시 시범 서비스 기간동안 TV기기 (스마트TV 및 안드로이드 STB App)에서 일부 콘텐츠를 UHD로 이용하실 수 있습니다.</span></p>
        <p class="dot-text"><span>다운로드 이용권은 방송VOD 중 원하시는 VOD를 선택하여 다운로드 하실 수 있으며, 잔여 다운로드 횟수는 이월되지 않습니다.</span></p>
        <p class="dot-text"><span>다운로드 무제한 이용권은 모바일 기기에서만 무제한 다운 가능하며, PC에서는 최대 30회까지 다운로드 가능합니다.</span></p>
        <!-- <p class="dot-text"><span>이용권 구매 시 지상파, 종편을 포함한 해외채널, 오디오 채널 등 70여 개 전체 LIVE채널을 광고 없이 시청할 수 있습니다.</span></p> -->
        <p class="dot-text"><span>제휴 이용권은 할인 혜택이 적용되어 있으므로 추가 혜택(페이백, 기타 할인 등)이 적용되지 않습니다.</span></p>
      </div>
    </div><!--ticket-notice//-->

    <div v-if="voucherType === 'pooq'" class="ticket-notice">
      <p class="ticket-noti-tit"><span class="col-purple-dark">Wavve</span>이용안내</p>
      <div class="tic-notice-right">
        <p class="dot-text"><span>콘텐츠 제공사의 사정에 따라 일부 콘텐츠는 FHD 화질을 지원하지 않을 수 있습니다.</span></p>
        <p class="dot-text"><span>FHD 이용권 구매 시 시범 서비스 기간동안 TV기기 (스마트TV 및 안드로이드 STB App)에서 일부 콘텐츠를 UHD로 이용하실 수 있습니다.</span></p>
        <p class="dot-text"><span>다운로드 이용권은 방송VOD 중 원하시는 VOD를 선택하여 다운로드 하실 수 있으며, 잔여 다운로드 횟수는 이월되지 않습니다.</span></p>
        <p class="dot-text"><span>다운로드 무제한 이용권은 모바일 기기에서만 무제한 다운 가능하며, PC에서는 최대 30회까지 다운로드 가능합니다.</span></p>
        <!-- <p class="dot-text"><span>이용권 구매 시 지상파, 종편을 포함한 해외채널, 오디오 채널 등 70여 개 전체 LIVE채널을 광고 없이 시청할 수 있습니다.</span></p> -->
      </div>
    </div><!--ticket-notice//-->

    <div v-if="voucherType === 'partner_bugs'" class="ticket-notice">
      <p class="ticket-noti-tit"><span class="col-purple-dark">벅스 제휴</span>이용안내</p>
      <div class="tic-notice-right">
        <p class="dot-text"><span>콘텐츠 제공사의 사정에 따라 일부 콘텐츠는 FHD 화질을 지원하지 않을 수 있습니다.</span></p>
        <p class="dot-text"><span>FHD 이용권 구매 시 시범 서비스 기간동안 TV기기 (스마트TV 및 안드로이드 STB App)에서 일부 콘텐츠를 UHD로 이용하실 수 있습니다.</span></p>
        <p class="dot-text"><span>다운로드 이용권은 방송VOD 중 원하시는 VOD를 선택하여 다운로드 하실 수 있으며, 잔여 다운로드 횟수는 이월되지 않습니다.</span></p>
        <p class="dot-text"><span>다운로드 무제한 이용권은 모바일 기기에서만 무제한 다운 가능하며, PC에서는 최대 30회까지 다운로드 가능합니다.</span></p>
        <p class="dot-text"><span>제휴 이용권은 할인 혜택이 적용되어 있으므로 추가 혜택(페이백, 기타 할인 등)이 적용되지 않습니다.</span></p>
      </div>
    </div>

    <div v-if="voucherType === 'partner_academy'" class="ticket-notice">
      <p class="ticket-noti-tit"><span class="col-purple-dark">아카데미</span>이용안내</p>
      <div class="tic-notice-right">
        <p class="dot-text"><span>아카데미 요금 혜택은 KEB하나은행,신한카드,우리카드와 제휴된 학생증 카드로 결제할 경우에만 추가 할인이 적용됩니다.</span><a
          href="/customer/notice_view.html?noticeId=1560" class="academy-link">할인대상 대학 확인하기</a></p>
        <p class="dot-text"><span>아카데미 요금제는 할인 혜택이 적용되어 있으므로 추가 혜택(페이백, 기타 할인 등)이 적용되지 않습니다.</span></p>
        <p class="dot-text"><span>콘텐츠 제공사의 사정에 따라 일부 콘텐츠는 FHD 화질을 지원하지 않을 수 있습니다.</span></p>
        <p class="dot-text"><span>FHD 이용권 구매 시 시범 서비스 기간동안 TV기기 (스마트TV 및 안드로이드 STB App)에서 일부 콘텐츠를 UHD로 이용하실 수 있습니다.</span></p>
        <p class="dot-text"><span>다운로드 이용권은 방송VOD 중 원하시는 VOD를 선택하여 다운로드 하실 수 있으며, 잔여 다운로드 횟수는 이월되지 않습니다.</span></p>
        <p class="dot-text"><span>다운로드 무제한 이용권은 모바일 기기에서만 무제한 다운 가능하며, PC에서는 최대 30회까지 다운로드 가능합니다.</span></p>
        <!-- <p class="dot-text"><span>이용권 구매 시 지상파, 종편을 포함한 해외채널, 오디오 채널 등 70여 개 전체 LIVE채널을 광고 없이 시청할 수 있습니다.</span></p> -->
      </div>
    </div><!--ticket-notice//-->

  </div>

</template>

<script>
export default {
  props: {
    voucherType: {
      type: String,
      required: true
    }
  }
}
</script>
